import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import i18next, { t } from 'i18next';
import { IconButton } from '@fluentui/react';
import { isNullUndefinedOrEmpty } from '../../../../../common/Helpers';
import { enum__ENUM_CLASE_PARTIDA, enum_CONTACTPARTIE_POLINOMY_FORM_VIEW, enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG, enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE } from '../../../../../common/Dictionaries';
import TablePolynomyItems from '../../../../../components/Products/sAdjustment/Polynomy/TablePolynomyItems';
import { action_updateContractPartieItem, action_updateContractPartieList, action_updateContractPartieSelected, action_updateContractPartieSelectedId, action_updateContractPartieSidePanelIsOpen, action_updateContractSubPartieSelected, action_updateContractSubPartieSelectedId, action_updateGeneralMessage } from '../../../../../reducers/actions/PAY/actions';
import { Col, Row } from 'react-bootstrap';
import { deleteSubPartie } from '../../../../../services/sPay/partie.service';
import DeleteAdvaiceDialog from '../../Dialogs/DeleteAdvaiceDialog';
import { _handleDeletePolynomyClick } from '../../../Events';


const TableResourceItem = ({ tableItem, contractPartieId, editEnabled }) => {

  const dispatch = useDispatch();

  const [forceCollapseExpand, setForceCollapseExpand] = useState(null);
  const [collapseExpand, setCollapseExpand] = useState(null);
  const [showDeleteAdvice, setShowDeleteAdvice] = useState(false);

  const {
    _contractParties: contractParties,
    _contractPartieSidePanelsConfig: contractPartieSidePanelsConfig,
  } = useSelector((state) => state.contractPartiesState);

  const handleViewItem = () => {
    const _contractPartieId = tableItem.iteM_SUBPARTIDA.partidaId;
    const contractPartie = contractParties.find(x => x.id === _contractPartieId);

    const contractSubPartieId = tableItem.id;
    const isPanelOpen = contractPartieSidePanelsConfig.isPanelViewSubPartieOpen;

    dispatch(action_updateContractPartieSelectedId(_contractPartieId))
    dispatch(action_updateContractPartieSelected(contractPartie))

    dispatch(action_updateContractSubPartieSelectedId(contractSubPartieId))
    dispatch(action_updateContractSubPartieSelected(tableItem))
    dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_SUBPARTIE_VIEW, !isPanelOpen))
  };

  const handleDeleteClick = async (responseFlag, tableItemId) => {
    if (responseFlag) {
      await deleteSubPartie(tableItemId).then((response) => {
        if (response.data.succeeded) {
          contractParties.forEach(contractPartie => {
            if (contractPartie.id === contractPartieId) {
              contractPartie.l_SUBPARTIDA = contractPartie.l_SUBPARTIDA.filter(subpartie => subpartie.id !== tableItemId);
            }
          });

          dispatch(action_updateContractPartieList(contractParties));
          dispatch(action_updateGeneralMessage(t('data-lang-msg-operationsucces')))
        }
        else {
            dispatch(action_updateGeneralMessage(t('data-lang-msg-operationerror'), true))
          }
      }).catch(() => {
          dispatch(action_updateGeneralMessage(t('data-lang-msg-operationerror'), true))
      });
    }
  };

  const handlePreDeleteClick = () => {
    setShowDeleteAdvice(true);
  }

  const handleEditClick = () => {
    const _contractPartieId = tableItem.iteM_SUBPARTIDA.partidaId;
    const contractPartie = contractParties.find(x => x.id === _contractPartieId);

    const contractSubPartieId = tableItem.id;
    const isPanelOpen = contractPartieSidePanelsConfig.isPanelEditPartieOpen;

    dispatch(action_updateContractPartieSelectedId(_contractPartieId))
    dispatch(action_updateContractPartieSelected(contractPartie))

    dispatch(action_updateContractSubPartieSelectedId(contractSubPartieId))
    dispatch(action_updateContractSubPartieSelected(tableItem))
    
    dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_SUBPARTIE_EDIT, !isPanelOpen))
  };

  const handleToggleRow = (item) => {
    const contractPartieId = tableItem.iteM_SUBPARTIDA.partidaId;
    const contractPartie = contractParties.find(x => x.id === contractPartieId);
    if (contractPartie.l_SUBPARTIDA.length > 0) {
      contractPartie.l_SUBPARTIDA.find(x => x.id === item.id).collapse = isNullUndefinedOrEmpty(item.collapse) ? false : !item.collapse
      dispatch(action_updateContractPartieItem(contractPartie))
    }
  };

  const manageCollapseExpandRowIcon = () => {
      return ((!isNullUndefinedOrEmpty(tableItem.collapse) ? tableItem.collapse : true) ? "CirclePlus" : "Blocked2")
  }

  return (
    <>
      <tr>
        <td className='text-end'>
          <IconButton iconProps={{ iconName: manageCollapseExpandRowIcon() }} onClick={() => handleToggleRow(tableItem)}/>
        </td>
        <td><span>{tableItem.iteM_SUBPARTIDA.nroRecurso}</span></td>
        <td><span>{tableItem.iteM_SUBPARTIDA.codigoRecurso}</span></td>
        <td><span>{tableItem.iteM_SUBPARTIDA.clasePartidaTitle}</span></td>
        <td><span>{tableItem.iteM_SUBPARTIDA.tipoPartidaTitle}</span></td>
        <td><span>{tableItem.iteM_SUBPARTIDA.nombreRecurso}</span></td>
        <td><span>{tableItem.iteM_SUBPARTIDA.gastoPrevioBaseRecurso.toLocaleString(i18next.language, {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
        <td><span>{(tableItem.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_SUMA_ALZADA ? tableItem.iteM_SUBPARTIDA.montoTotalSumaAlzada : (tableItem.iteM_SUBPARTIDA.cantidadTotalRecurso * tableItem.iteM_SUBPARTIDA.precioUnitarioBaseRecurso)).toLocaleString(i18next.language, {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></td>
        <td><span>{tableItem.iteM_SUBPARTIDA.codigoInterno}</span></td>
        <td className='text-end'>
          <IconButton
            className="btn btn-outline-secondary btn-sm delete-btn me-1"
            iconProps={{iconName: "View"}}
            onClick={handleViewItem}
            title={t('data-lang-btn-view')}
          />
          {
            editEnabled &&
            <>     
              <IconButton
                className="btn btn-outline-primary btn-sm mr-2 edit-btn me-1"
                iconProps={{iconName: "Edit"}}
                onClick={handleEditClick}
                title={t('data-lang-btn-edit')}
              />
              <IconButton
                className="btn btn-outline-danger btn-sm delete-btn"
                iconProps={{iconName: "Delete"}}
                onClick={handlePreDeleteClick}
                title={t('data-lang-btn-delete')}
              />
            </>
          }
        </td>
      </tr>
      {
        (forceCollapseExpand ? collapseExpand : (!(!isNullUndefinedOrEmpty(tableItem.collapse) ? tableItem.collapse : true))) &&
        <tr>
          <td colSpan={10}>
            <Row>
              <Col className='text-end col-auto me-auto'>
                <Row ID="vSubpartida">
                  <Col>
                    {
                      tableItem.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_SUMA_ALZADA &&
                      <Row ID="pnlSumaAlzada" >
                        <Col className="moduloInfoLeft">
                          <Row>
                            <Col className="headerDetailPartida">Monto total </Col>
                            <Col className="">
                                {
                                  tableItem.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_SUMA_ALZADA ?
                                  tableItem.iteM_SUBPARTIDA.montoTotalPartida : "S/D"
                                }
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    }
                    {
                      tableItem.iteM_SUBPARTIDA.clasePartidaId === enum__ENUM_CLASE_PARTIDA.SRP_PRECIO_UNITARIO &&
                      <Row ID="pnlPrecioUnitario" >
                        <Col className="moduloInfoLeft">
                          <Row className='text-nowrap'>
                            <Col className="headerDetailPartida">Unidad recurso</Col>
                            <Col className="">
                                { tableItem.iteM_SUBPARTIDA.unidadPartidaTitle }
                            </Col>
                          </Row>
                          <Row className='text-nowrap'>
                            <Col className="headerDetailPartida">Cantidad previa recurso</Col>
                            <Col className="">
                                { tableItem.iteM_SUBPARTIDA.cantidadPreviaRecurso && tableItem.iteM_SUBPARTIDA.cantidadPreviaRecurso.toLocaleString(i18next.language) }
                            </Col>
                          </Row>
                          <Row className='text-nowrap'>
                            <Col className="headerDetailPartida">Cantidad total recurso</Col>
                            <Col className="">
                                { tableItem.iteM_SUBPARTIDA.cantidadTotalRecurso && tableItem.iteM_SUBPARTIDA.cantidadTotalRecurso.toLocaleString(i18next.language) }
                            </Col>
                          </Row>
                          <Row className='text-nowrap'>
                            <Col className="headerDetailPartida">Precio unitario base recurso</Col>
                            <Col className="">
                                { tableItem.iteM_SUBPARTIDA.precioUnitarioBaseRecurso && parseFloat(tableItem.iteM_SUBPARTIDA.precioUnitarioBaseRecurso).toLocaleString(i18next.language) }
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    }
                  </Col>
                </Row>
              </Col>
              {
                tableItem.iteM_SUBPARTIDA.clasePartidaId !== enum__ENUM_CLASE_PARTIDA.PSP_CONSUMO_RECURSOS & tableItem.iteM_SUBPARTIDA.clasePartidaId !== enum__ENUM_CLASE_PARTIDA.PCI_CONSUMO_RECURSOS &&
                <Col className='d-flex w-100'>
                  <TablePolynomyItems
                    parentId={tableItem.iteM_SUBPARTIDA.id}
                    tableItems={tableItem.l_SUBPOLINOMIO}
                    parentPolinomyType={enum_CONTRACTPARTIE_PARENT_PONINOMY_TYPE.SUBPARTIE}
                    handleDeletePolynomy={_handleDeletePolynomyClick}
                    polynomyViewType={enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.SIMPLE_VIEW}
                  />
                </Col>
              }
            </Row>
          </td>
        </tr>
      }
      {
        <DeleteAdvaiceDialog
          isModalOpen={showDeleteAdvice}
          setIsModalOpen={setShowDeleteAdvice}
          setterAction={handleDeleteClick}
          itemIdToDelete={tableItem.id}
        />
      }
    </>
  );
};

TableResourceItem.propTypes = {
  tableItem: PropTypes.shape({
    id: PropTypes.number,
    subject: PropTypes.string,
    category: PropTypes.string,
    assignee: PropTypes.string,
    priority: PropTypes.string,
    status: PropTypes.string,
    update: PropTypes.bool,
    creation_date: PropTypes.string,
    answers_number: PropTypes.number,
    has_docs: PropTypes.bool
  }),

};

TableResourceItem.defaultProps = {
  tableItem: {
    id: 1,
    subject: 'A new rating has been received',
    category: 'Marketing',
    assignee: 'Erwin',
    priority: 'Medium',
    status: 'Open',
    update: false,
    creation_date: '',
    answers_number: 0,
    has_docs: false
  },
};

export default TableResourceItem;
